<template>
  <div class="layer-tem">
    <!-- 关闭按钮 -->
    <img :src="close" class="close-btn" alt="" @click="closeLayer">
    <!-- 主内容 -->
    <div class="layer-main">
      <!-- 块 -->
      <div class="block-list">
        <div class="block-head">
          <div class="tit-wrap">
            <!-- 标题 -->
            <div class="tit">
              警情遗留未处理数量单位排名
            </div>
            <!-- 下拉框 -->
            <div class="select-wrap">
              <Select v-model="typeIndex" transfer :word-wrap="true" style="width: 100px;margin-right: 10px;"
                @on-change="typeSelect">
                <Option v-for="(item, index) in typeArr" :value="item.index" :key="index">
                  {{ item.text }}
                </Option>
              </Select>
            </div>
          </div>
          <div class="right-form-wrap">
            <!-- 今日、本周、本月 -->
            <div>
              <Select v-model="dateIndex" transfer :word-wrap="true" style="width: 100px;margin-right: 10px;"
                @on-change="dateTypeSelect">
                <Option v-for="(item, index) in dateTypeArr" :value="index" :key="index">
                  {{ item }}
                </Option>
              </Select>
            </div>
            <!-- 升序降序 -->
            <div class="order-wrap" @click="setOrder">
              <span class="order-text">
                {{ orderStatus ? '升序' : '降序' }}
              </span>
              <div class="order-i-wrap">
                <i class="iconfont" :class="{ 'active': orderStatus }">&#xe615;</i>
                <i class="iconfont" :class="{ 'active': !orderStatus }">&#xeaca;</i>
              </div>
            </div>
          </div>
        </div>
        <div class="block-main">
          <div class="block-main-content">
            <!-- echart图 -->
            <div class="echart" ref="echart" v-show="echartArr.length"></div>
            <p class="no-data" v-show="!echartArr.length && getEchartStatus">
              暂无数据
            </p>
          </div>
        </div>
      </div>
      <div class="block-list">
        <!-- 标题 -->
        <div class="tit" style="width: 300px;">
          {{ parTit }}警情信息
        </div>
      </div>
      <!-- 块 -->
      <div class="block-list">
        <div class="block-head block-head-text">
          <div class="tit-wrap">

            <!-- 消防负责人 -->
            <div class="text">
              消防负责人：{{ titleTextObj.chargePersonName }}
            </div>
            <!-- 联系方式 -->
            <div class="text">
              联系方式：{{ titleTextObj.chargePersonTel }}
            </div>
          </div>
          <div class="form-wrap">
            <!-- 设备名称 -->
            <Select v-model="deviceId" transfer :word-wrap="true" clearable placeholder="设备名称" style="width: 150px;"
              @on-change="selectFn">
              <Option v-for="item in deviceDetailList" :value="item.id" :key="item.id">
                {{ item.name }}
              </Option>
            </Select>
            <!-- 时间筛选 -->
            <DatePicker transfer :word-wrap="true" type="daterange" placeholder="时间筛选" @on-change="timeSearch"
              format="yyyy-MM-dd HH:mm" style="width: 150px;" v-model='timeSelet' :options="optionWeek"
              v-if="dateIndex == 1"></DatePicker>
            <DatePicker transfer :word-wrap="true" type="daterange" placeholder="时间筛选" @on-change="timeSearch"
              format="yyyy-MM-dd HH:mm" style="width: 150px;" v-model='timeSelet' :options="optionMonth"
              v-if="dateIndex == 2"></DatePicker>
            <!-- 处理状态 -->
            <!-- <Select 
                    v-model="status"
                    transfer 
                    :word-wrap="true"
                    clearable
                    style="width: 100px;"
                    placeholder="处理状态"
                    @on-change="selectFn"
                    v-if="typeIndex == 1"
                >
                    <Option value="1">未处理</Option>
                    <Option value="2">已处理</Option>
                    <Option value="3">处理中</Option>
                </Select> -->
            <!-- 报警类型 -->
            <Select v-model="baojing" transfer :word-wrap="true" clearable style="width: 150px;" placeholder="报警类型"
              @on-change="selectFn" v-if="typeIndex == 1">
              <Option v-for="item in bjTypeList" :value="item.code" :key="item.code">
                {{ item.name }}
              </Option>
            </Select>
            <!-- 预警类型 -->
            <Select v-model="baojing" transfer :word-wrap="true" clearable placeholder="预警类型" style="width: 150px;"
              @on-change="selectFn" v-if="typeIndex == 2">
              <Option v-for="item in yjTypeList" :value="item.code" :key="item.code">
                {{ item.name }}
              </Option>
            </Select>
            <!-- 故障类型 -->
            <Select v-model="guzhang" transfer :word-wrap="true" clearable style="width: 150px;" placeholder="故障类型"
              @on-change="selectFn" v-if="typeIndex == 4">
              <Option v-for="item in guZList" :value="item.code" :key="item.code">
                {{ item.name }}
              </Option>
            </Select>
            <!-- 事件来源 -->
            <!-- <Select 
                    v-model="eventSource"
                    transfer 
                    :word-wrap="true"
                    clearable
                    style="width: 100px;"
                    @on-change="selectFn"
                    placeholder="事件来源"
                    v-if="typeIndex == 4"
                >
                   <Option
                            v-for="item in eventSourceArr"
                            :value="item.code"
                            :key="item.code"
                    >
                        {{ item.name }}
                    </Option>
                </Select> -->
          </div>
        </div>
        <div class="block-main">
          <!-- 列表 滚动加载更多 -->
          <div class="block-main-content">
            <!-- 列表 滚动加载更多 -->
            <div class="table-wrap">
              <div class="table-head">
                <table>
                  <tr v-if="typeIndex == 0">
                    <th width="10%">
                      序号
                    </th>
                    <th width="20%">
                      火警时间
                    </th>
                    <th width="10%">
                      设备名称
                    </th>
                    <th width="20%">
                      火警内容
                    </th>
                    <!-- <th width="20%">
                      安装位置
                    </th> -->
                    <th width="10%">
                      处理状态
                    </th>
                    <th width="10%">
                      操作
                    </th>
                  </tr>
                  <tr v-if="typeIndex == 1">
                    <th width="10%">
                      序号
                    </th>
                    <th width="10%">
                      报警时间
                    </th>
                    <th width="10%">
                      设备名称
                    </th>
                    <th width="10%">
                      报警类型
                    </th>
                    <th width="15%">
                      报警内容
                    </th>
                    <!-- <th width="15%">
                      位置
                    </th> -->
                    <th width="10%">
                      处理状态
                    </th>
                    <th width="10%">
                      图片
                    </th>
                    <th width="10%">
                      操作
                    </th>
                  </tr>
                  <tr v-if="typeIndex == 2">
                    <th width="10%">
                      序号
                    </th>
                    <th width="10%">
                      预警时间
                    </th>
                    <th width="10%">
                      设备名称
                    </th>
                    <th width="10%">
                      预警类型
                    </th>
                    <th width="15%">
                      预警内容
                    </th>
                    <!-- <th width="15%">
                      位置
                    </th> -->
                    <th width="10%">
                      处理状态
                    </th>
                    <th width="10%">
                      图片
                    </th>
                    <th width="10%">
                      操作
                    </th>
                  </tr>
                  <tr v-if="typeIndex == 3">
                    <th width="10%">
                      序号
                    </th>
                    <th width="10%">
                      设备名称
                    </th>
                    <th width="30%">
                      隐患内容
                    </th>
                    <!-- <th width="20%">
                      位置
                    </th> -->
                    <th width="20%">
                      隐患时间
                    </th>
                    <th width="10%">
                      操作
                    </th>
                  </tr>
                  <tr v-if="typeIndex == 4">
                    <th width="10%">
                      序号
                    </th>
                    <th width="10%">
                      故障时间
                    </th>
                    <th width="10%">
                      设备名称
                    </th>
                    <th width="10%">
                      故障类型
                    </th>
                    <th width="10%">
                      故障内容
                    </th>
                    <!-- <th width="10%">
                      位置
                    </th> -->
                    <th width="10%">
                      处理状态
                    </th>
                    <th width="10%">
                      操作
                    </th>
                  </tr>
                </table>
              </div>
              <div class="table-body" id="layer-tem-leftTop">
                <table v-show="typeIndex == 0">
                  <tr v-for="(item, index) in tableListArr" :key="index">
                    <td width="10%">
                      <Poptip trigger="hover" transfer :word-wrap="true" :content="index + 1">
                        {{ index + 1 }}
                      </Poptip>
                    </td>
                    <td width="20%" title="">
                      <Poptip v-if="item.ctime" trigger="hover" transfer :word-wrap="true"
                        :content="timestamp(item.ctime)">
                        {{ timestamp(item.ctime) }}
                      </Poptip>
                    </td>
                    <td width="10%">
                      <Poptip v-if="item.deviceName" trigger="hover" transfer :word-wrap="true"
                        :content="item.deviceName">
                        {{ item.deviceName }}
                      </Poptip>
                    </td>
                    <td width="20%">
                      <Poptip v-if="item.content" trigger="hover" transfer :word-wrap="true" :content="item.content">
                        {{ item.content }}
                      </Poptip>
                    </td>
                    <!-- <td width="20%">
                      <Poptip
                        v-if="item.address"
                        trigger="hover"
                        transfer
                        :word-wrap="true"
                        :content="item.address"
                      >
                        {{item.address}}
                      </Poptip>
                    </td> -->
                    <td width="10%">
                      <Poptip v-if="item.state" trigger="hover" transfer :word-wrap="true" :content="item.state">
                        {{ item.state }}
                      </Poptip>
                    </td>
                    <td width="10%">
                      <div class="td-option-wrap">
                        <i class="iconfont" :class="{ 'active': item.cameras }"
                          @click="openHls(item.cameras)">&#xe7bc;</i>

                        <!-- <i
                                class="iconfont"
                                :class="{'active': item.position}"
                                @click="showLocation(item.position)"
                            >
                                &#xe618;
                            </i> -->
                      </div>
                    </td>
                  </tr>
                </table>
                <table v-show="typeIndex == 1 || typeIndex == 2">
                  <tr v-for="(item, index) in tableListArr" :key="index">
                    <td width="10%">
                      <Poptip trigger="hover" transfer :word-wrap="true" :content="index + 1">
                        {{ index + 1 }}
                      </Poptip>
                    </td>
                    <td width="10%">
                      <Poptip v-if="item.ctime" trigger="hover" transfer :word-wrap="true"
                        :content="timestamp(item.ctime)">
                        {{ timestamp(item.ctime) }}
                      </Poptip>
                    </td>
                    <td width="10%">
                      <Poptip v-if="item.deviceName" trigger="hover" transfer :word-wrap="true"
                        :content="item.deviceName">
                        {{ item.deviceName }}
                      </Poptip>
                    </td>
                    <td width="10%">
                      <Poptip v-if="item.typeName" trigger="hover" transfer :word-wrap="true" :content="item.typeName">
                        {{ item.typeName }}
                      </Poptip>
                    </td>
                    <td width="15%">
                      <Poptip v-if="item.content" trigger="hover" transfer :word-wrap="true" :content="item.content">
                        {{ item.content }}
                      </Poptip>
                    </td>
                    <!-- <td width="15%">
                      <Poptip
                        v-if="item.address"
                        trigger="hover"
                        transfer
                        :word-wrap="true"
                        :content="item.address"
                      >
                        {{item.address}}
                      </Poptip>
                    </td> -->
                    <td width="10%">
                      <Poptip v-if="item.state" trigger="hover" transfer :word-wrap="true" :content="item.state">
                        {{ item.state }}
                      </Poptip>
                    </td>
                    <td width="10%">
                      <i class="iconfont imgView" :class="{ 'active': !item.imgPath }"
                        @click="showImg(item.imgPath)">&#xe635;</i>
                    </td>
                    <td width="10%">
                      <div class="td-option-wrap">
                        <i class="iconfont" :class="{ 'active': item.cameras }"
                          @click="openHls(item.cameras)">&#xe7bc;</i>

                        <!-- <i
                                    class="iconfont"
                                    :class="{'active': item.position}"
                                    @click="showLocation(item.position)"
                                >
                                    &#xe618;
                                </i> -->
                      </div>
                    </td>
                  </tr>
                </table>
                <table v-show="typeIndex == 3">
                  <tr v-for="(item, index) in tableListArr" :key="index">
                    <td width="10%">
                      <Poptip trigger="hover" transfer :word-wrap="true" :content="index + 1">
                        {{ index + 1 }}
                      </Poptip>
                    </td>
                    <td width="10%">
                      <Poptip v-if="item.deviceName" trigger="hover" transfer :word-wrap="true"
                        :content="item.deviceName">
                        {{ item.deviceName }}
                      </Poptip>
                    </td>
                    <td width="30%">
                      <Poptip v-if="item.content" trigger="hover" transfer :word-wrap="true" :content="item.content">
                        {{ item.content }}
                      </Poptip>
                    </td>
                    <!-- <td width="20%">
                      <Poptip
                        v-if="item.position"
                        trigger="hover"
                        transfer
                        :word-wrap="true"
                        :content="item.address"
                      >
                        {{item.address}}
                      </Poptip>
                    </td> -->
                    <td width="20%">
                      <Poptip v-if="item.ctime" trigger="hover" transfer :word-wrap="true"
                        :content="timestamp(item.ctime)">
                        {{ timestamp(item.ctime) }}
                      </Poptip>
                    </td>
                    <td width="10%">
                      <div class="td-option-wrap">
                        <i class="iconfont" :class="{ 'active': item.cameras }"
                          @click="openHls(item.cameras)">&#xe7bc;</i>

                        <!-- <i
                                        class="iconfont"
                                        :class="{'active': item.position}"
                                        @click="showLocation(item.position)"
                                >
                                    &#xe618;
                                </i> -->
                      </div>
                    </td>
                  </tr>
                </table>
                <table v-show="typeIndex == 4">
                  <tr v-for="(item, index) in tableListArr" :key="index">
                    <td width="10%">
                      <Poptip trigger="hover" transfer :word-wrap="true" :content="index + 1">
                        {{ index + 1 }}
                      </Poptip>
                    </td>
                    <td width="10%">
                      <Poptip v-if="item.ctime" trigger="hover" transfer :word-wrap="true"
                        :content="timestamp(item.ctime)">
                        {{ timestamp(item.ctime) }}
                      </Poptip>
                    </td>
                    <td width="10%">
                      <Poptip v-if="item.deviceName" trigger="hover" transfer :word-wrap="true"
                        :content="item.deviceName">
                        {{ item.deviceName }}
                      </Poptip>
                    </td>
                    <td width="10%">
                      <Poptip v-if="item.typeName" trigger="hover" transfer :word-wrap="true" :content="item.typeName">
                        {{ item.typeName }}
                      </Poptip>
                    </td>
                    <td width="10%">
                      <Poptip v-if="item.content" trigger="hover" transfer :word-wrap="true" :content="item.content">
                        {{ item.content }}
                      </Poptip>
                    </td>
                    <!-- <td width="10%">
                      <Poptip
                        v-if="item.address"
                        trigger="hover"
                        transfer
                        :word-wrap="true"
                        :content="item.address"
                      >
                        {{item.address}}
                      </Poptip>
                    </td> -->
                    <td width="10%">
                      <Poptip v-if="item.state" trigger="hover" transfer :word-wrap="true" :content="item.state">
                        {{ item.state }}
                      </Poptip>
                    </td>
                    <td width="10%">
                      <div class="td-option-wrap">
                        <i class="iconfont" :class="{ 'active': item.cameras }"
                          @click="openHls(item.cameras)">&#xe7bc;</i>

                        <!-- <i
                                    class="iconfont"
                                    :class="{'active': item.position}"
                                    @click="showLocation(item.position)"
                                >
                                    &#xe618;
                                </i> -->
                      </div>
                    </td>
                  </tr>
                </table>
                <p class="no-data" v-show="!tableListArr.length && getDetailStatus">
                  暂无数据
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Modal v-model="hlsModal" width="800" @on-cancel="hlsCancel" footer-hide title="视频监控">
      <div class="video_layer" style="margin:auto;width:700px;" v-if="hlsModal">
        <div class="video-title">
          <div>{{ videoName }}</div>
          <div class="video-btn">
            <img v-if="videoIndex > 0" style=" cursor: pointer;" @click="videoClick('prev')"
              src="@/assets/images/videoControl/zuo.png" alt="">
            <img v-else src="@/assets/images/videoControl/zuo1.png" alt="">
            <img v-if="videoIndex + 1 < videoTotal" style="margin-left:15px;cursor: pointer;"
              src="@/assets/images/videoControl/you.png" @click="videoClick('next')" alt="">
            <img v-else style="margin-left:15px" src="@/assets/images/videoControl/you1.png" alt="">
          </div>
        </div>
        <videoPlay :previewUrl="videoSrc" :videoId="992" :channelNum="channelNum" :videoSid="videoSid" :videoDeviceId="videoDeviceId" v-if="showVideo"
          @hideClose="videoSrc = ''" :height="350" :showClose="false" />
        <div v-else style="height:350px">
        </div>
      </div>

    </Modal>
  </div>
</template>
<script>
import close from "@/assets/img/close.png";
import videoPlay from "../videoPlay/videoPlay.vue";
import { themeArr } from "@/assets/js/theme.js";
import { contBlockUrl, buildings } from "@/assets/js/url.js";
import { getTime, returnDay, timestampToTime } from "@/assets/js/index";
import videojs from "video.js";
export default {
  name: "",
  data: () => ({
    hlsModal: false,
    videoSrc: "",
    videoDeviceId: "",
    channelNum: "",
    videoSid: "",
    showVideo: false,
    videoName: "",
    videoIndex: 0,
    camerasList: [],
    close,
    tabArr: ["区域", "行业"],
    tabIndex: 0,
    hashValue: "",
    loginData: {},
    currentPage: 1,
    typeArr: [
      {
        text: "火警",
        index: 0,
      },
      {
        text: "报警",
        index: 1,
      },
      {
        text: "预警",
        index: 2,
      },
      {
        text: "隐患",
        index: 3,
      },
      {
        text: "故障",
        index: 4,
      },
    ],
    typeIndex: 0,
    dateIndex: 0,
    dateTypeArr: ["今日", "本周", "本月"],
    // dayType: '今日',
    parTit: "",
    timeSelet: "",
    deviceId: "",
    deviceDetailList: [],
    titleTextObj: {
      chargePersonName: "",
      chargePersonTel: "",
    },
    echartDom: null,
    echarts_color: themeArr[0].color,
    echartOrgId: "",
    beginTime: null,
    endTime: null,
    tableListArr: [],
    // inpVal: '',
    totalCount: "",
    getDetailStatus: false,
    modalShow: false,
    modalImgSrc: "",
    modalVideoSrc: "",
    videoArr: [],
    orderStatus: false,
    status: "",
    baojing: "",
    guzhang: "",
    // eventSource: '',
    bjTypeList: [],
    yjTypeList: [],
    guZList: [],
    eventSourceArr: [
      {
        code: 1,
        name: "部件",
      },
      {
        code: 2,
        name: "巡检",
      },
      {
        code: 3,
        name: "消防主机",
      },
      {
        code: 4,
        name: "用户传输装置",
      },
      {
        code: 5,
        name: "摄像头",
      },
      {
        code: 6,
        name: "消防主机下挂装置[带点表]",
      },
      {
        code: 7,
        name: "消防主机下挂装置[无点表]打印口",
      },
    ],
    getEchartStatus: false,
    echartArr: [],
    optionWeek: {
      disabledDate(date) {
        var _date = new Date();
        // 本周一的日期
        _date.setDate(
          _date.getDate() - (_date.getDay() == 0 ? 7 : _date.getDay()) + 1
        );
        var begin =
          _date.getFullYear() +
          "-" +
          (_date.getMonth() + 1) +
          "-" +
          _date.getDate() +
          " 00:00:00";
        // 本周日的日期
        _date.setDate(_date.getDate() + 6);
        var end =
          _date.getFullYear() +
          "-" +
          (_date.getMonth() + 1) +
          "-" +
          _date.getDate() +
          " 23:59:59";
        return (
          date.valueOf() < new Date(begin).getTime() ||
          date.valueOf() > new Date(end).getTime()
        );
      },
    },
    optionMonth: {
      disabledDate(date) {
        let dateTime = new Date();
        let currentYear = dateTime.getFullYear();
        let currentMonth = dateTime.getMonth();
        let monthFirstDay = new Date(currentYear, currentMonth, 1);

        let newMonth = ++currentMonth;
        let newYear = currentYear;
        if (newMonth >= 12) {
          newMonth -= 12;
          newYear++;
        }
        let nextMonthFirst = new Date(newYear, newMonth, 1);
        let nonthLastDay = new Date(
          nextMonthFirst.getTime() - 24 * 60 * 60 * 1000
        );
        return (
          date.valueOf() < new Date(monthFirstDay).getTime() ||
          date.valueOf() > new Date(nonthLastDay).getTime()
        );
      },
    },
  }),
  components: {
    videoPlay,
  },
  watch: {
    headDateIndex: {
      handler(res, oldVal) {
        console.log(res);
        console.log("头部日期选择");
        this.dateIndex = res;
        // switch (res) {
        //     case 0: //日
        //         this.dayType = '今日';
        //         break;
        //     case 1: //周
        //         this.dayType = '本周';
        //         break;
        //     case 2: //月
        //         this.dayType = '本月';
        //         break;
        // }
        //echart图保持联动
        this.getEchartData();
      },
      //   immediate: true,
      deep: true,
    },
    navIndex: {
      handler(newVal, oldVal) {
        //改变火警、报警类型
        console.log(newVal);
        if (this.echartDom) {
          this.echartDom.clear();
        }
        $JQ("#layer-tem-leftTop").mCustomScrollbar("update");
        this.$nextTick(() => {
          this.typeIndex = newVal;
          if (this.typeIndex == 1 && !this.bjTypeList.length) {
            this.getTypeL();
          } else if (this.typeIndex == 2 && !this.yjTypeList.length) {
            this.getYjTypeL();
          } else if (this.typeIndex == 4 && !this.guZList.length) {
            this.getGzTypeL();
          }
          this.getEchartData();
        });
      },
      // immediate: true,
      deep: true,
    },
  },
  created() {
    this.hashValue = localStorage.getItem("hashValue");
    this.loginData = JSON.parse(localStorage.getItem("loginData"));
    this.dateIndex = this.$store.state.headDate.index;
    this.typeIndex = this.$store.state.leftTopNavIndex;
    this.getTimeFn();
    if (this.typeIndex == 1 && !this.bjTypeList.length) {
      this.getTypeL();
    } else if (this.typeIndex == 2 && !this.yjTypeList.length) {
      this.getYjTypeL();
    } else if (this.typeIndex == 4 && !this.guZList.length) {
      this.getGzTypeL();
    }
  },
  mounted() {
    this.getEchartData();
  },
  computed: {
    headDateIndex() {
      return this.$store.state.headDate.index;
    },
    navIndex() {
      return this.$store.state.leftTopNavIndex;
    },
  },
  methods: {
    getGzTypeL() {
      let dataObj = {
        type: "get",
        url: contBlockUrl.yjGzType,
        obj: {
          currentPage: 1,
          pageSize: 1000,
          exceptionType: 3,
        },
      };
      this.$Axios(dataObj).then((res) => {
        console.log(res.data.data);
        console.log("故障列表");

        this.guZList = res.data.data;
      });
    },
    getYjTypeL() {
      let dataObj = {
        type: "get",
        url: contBlockUrl.yjGzType,
        obj: {
          currentPage: 1,
          pageSize: 1000,
          exceptionType: 1,
        },
      };
      this.$Axios(dataObj).then((res) => {
        console.log(res.data.data);
        console.log("预警类型");

        this.yjTypeList = res.data.data;
      });
    },
    getTypeL() {
      let dataObj = {
        type: "get",
        url: contBlockUrl.bjType,
        obj: {
          currentPage: 1,
          pageSize: 1000,
          exceptionType: 2,
        },
      };
      this.$Axios(dataObj).then((res) => {
        console.log(res.data.data);
        console.log("报警类型数据");

        this.bjTypeList = res.data.data;
      });
    },
    showImg(imgSrc) {
      if (!imgSrc) {
        return;
      }
      this.modalShow = true;
      this.modalImgSrc = imgSrc;
    },
    setOrder() {
      this.orderStatus = !this.orderStatus;
      this.getEchartData();
    },
    modalChangeg(status) {
      if (!status) {
        this.modalImgSrc = "";
        this.modalVideoSrc = "";
        // this.$nextTick(()=>{
        //     this.videoDispose();
        // });
      }
    },
    initVideo(url) {
      if (this.player) {
        this.player.src(url);
        this.player.play();
        return;
      }
      this.player = videojs(
        "xfVideo",
        {
          src: url,
          autoplay: true,
          width: 768,
          height: 500,
        },
        function () {
          videojs.log("播放器已经准备好了!");
        }
      );
    },
    videoDispose(id) {
      if (this.player) {
        this.player.dispose();
        this.player = null;
        this.videoArr.pop();
      }
    },
    openHls(cameras) {
      //消防运行情况 操作列 视频
      console.log(cameras);
      if (cameras && cameras.length > 0) {
        this.videoTotal = cameras.length;
        this.camerasList = cameras;
        this.videoSrc = this.camerasList[this.videoIndex].hlsAddr;
        this.videoDeviceId = this.camerasList[this.videoIndex].id;
        this.channelNum = this.camerasList[this.videoIndex].channelNum;
        this.videoSid = this.camerasList[this.videoIndex].num;
        this.videoName = this.camerasList[this.videoIndex].name;
        this.hlsModal = true;
        this.showVideo = true;
      }
    },
    videoClick(type) {
      this.showVideo = false;
      if (type == "next") {
        this.videoIndex++;
      } else {
        this.videoIndex--;
      }

      this.videoSrc = this.camerasList[this.videoIndex].hlsAddr;
      this.videoDeviceId = this.camerasList[this.videoIndex].id;
      this.channelNum = this.camerasList[this.videoIndex].channelNum;
      this.videoSid = this.camerasList[this.videoIndex].num;
      this.videoName = this.camerasList[this.videoIndex].name;
      setTimeout(() => {
        this.showVideo = true;
      }, 300);
    },
    hlsCancel() {
      // 关闭视频弹框
      // this.player.pause()
      this.hlsModal = false;
      this.videoIndex = 0;
      this.camerasList = [];
      this.videoTotal = "";
      this.videoSrc = "";
      this.videoName = "";
    },
    showLocation(position) {
      //定位
      this.$store.commit("showMap", {
        status: true,
        position: position,
      });
    },
    timestamp(time) {
      return timestampToTime(time);
    },
    closeLayer() {
      this.$store.commit("showLayer", {
        status: false,
        type: "",
      });
    },
    typeSelect() {
      //类型下拉选
      this.getTimeFn();
      this.timeSelet = "";
      this.deviceId = "";
      this.baojing = "";
      this.guzhang = "";

      this.currentPage = 1;
      this.tableListArr = [];
      $JQ("#layer-tem-leftTop").mCustomScrollbar("update");
      this.$nextTick(() => {
        if (this.typeIndex == 1 && !this.bjTypeList.length) {
          this.getTypeL();
        } else if (this.typeIndex == 2 && !this.yjTypeList.length) {
          this.getYjTypeL();
        } else if (this.typeIndex == 4 && !this.guZList.length) {
          this.getGzTypeL();
        }
        this.getEchartData();
      });
    },
    selectFn() {
      //设备名称
      //获取table数据
      (this.currentPage = 1), (this.tableListArr = []);
      this.getTableData();
    },
    timeSearch(res) {
      //时间筛选
      console.log(res);
      console.log('时间选择器 change 触发', res);
      if (!res || !Array.isArray(res)) {
        // 如果是 null、undefined 或者不是数组，则跳过
        return;
      }
      const [start, end] = res;
      if (!start || !end) {
        this.getTimeFn();
      } else {
        this.beginTime = new Date(res[0]).getTime();
        this.endTime = new Date(res[1]).getTime();
      }
      (this.currentPage = 1), (this.tableListArr = []);
      this.getTableData();
    },
    deviceDetail(orgId) {
      let dataObj = {
        type: "get",
        url: contBlockUrl.dwDeviceList,
        obj: {
          currentPage: 1,
          pageSize: 1000,
          orgId: orgId,
        },
      };
      this.$Axios(dataObj).then((res) => {
        console.log(res);
        console.log("设备接口数据");

        if (res.data.success) {
          this.deviceDetailList = res.data.data;
        }
      });
    },
    weekDate() {
      //本周时间
      var date = new Date();
      // 本周一的日期
      date.setDate(
        date.getDate() - (date.getDay() == 0 ? 7 : date.getDay()) + 1
      );
      var begin =
        date.getFullYear() +
        "-" +
        (date.getMonth() + 1) +
        "-" +
        date.getDate() +
        " 00:00:00";
      // 本周日的日期
      date.setDate(date.getDate() + 6);
      var end =
        date.getFullYear() +
        "-" +
        (date.getMonth() + 1) +
        "-" +
        date.getDate() +
        " 23:59:59";
      return [begin, end];
    },
    monthDate() {
      let date = new Date();
      let currentMonth = date.getMonth();
      let nextMonth = ++currentMonth;
      let nextMonthFirstDay = new Date(date.getFullYear(), nextMonth, 1);
      let oneDay = 1000 * 60 * 60 * 24;
      let end =
        new Date(nextMonthFirstDay - oneDay)
          .toLocaleDateString()
          .replace(/\//g, "-") + " 23:59:59";
      let begin =
        new Date(date.setDate(1)).toLocaleDateString().replace(/\//g, "-") +
        " 00:00:00";
      return [begin, end];
    },
    getTimeFn() {
      //设置日期
      switch (this.dateIndex) {
        case 0: //今日
          let _beginTime =
            new Date().toLocaleDateString().replace(/\//g, "-") + " 00:00:00";
          let _endTime =
            new Date().toLocaleDateString().replace(/\//g, "-") + " 23:59:59";
          this.beginTime = new Date(_beginTime).getTime();
          this.endTime = new Date(_endTime).getTime();
          break;
        case 1: //本周
          this.beginTime = new Date(this.weekDate()[0]).getTime();
          this.endTime = new Date(this.weekDate()[1]).getTime();
          break;
        case 2: //本月
          this.beginTime = new Date(this.monthDate()[0]).getTime();
          this.endTime = new Date(this.monthDate()[1]).getTime();
          break;
      }
    },
    dateTypeSelect() {
      //日期类型下拉
      this.getTimeFn();
      this.getEchartData();

    },
    getEchartData() {
      this.getEchartStatus = false;
      if (this.echartDom) {
        this.echartDom.clear();
      }
      // this.beginTime = '';
      // this.endTime = '';
      (this.currentPage = 1), (this.tableListArr = []);
      this.parTit = "";
      this.titleTextObj = {
        chargePersonName: "",
        chargePersonTel: "",
      };
      let dateType = "";
      switch (this.dateIndex) {
        case 0:
          dateType = "thisDay";
          break;
        case 1:
          dateType = "thisWeek";
          break;
        case 2:
          dateType = "thisMonth";
          break;
      }
      let states = "";
      let type = "";
      switch (this.typeIndex) {
        case 0:
          states = "0,1";
          type = "flamingFire";
          break;
        case 1:
          states = "0,1";
          type = "fire";
          break;
        case 2:
          states = "0";
          type = "warn";
          break;
        case 3:
          states = "0";
          type = "hiddenHazard"; //隐患
          break;
        case 4:
          states = "0";
          type = "fault"; //故障
          break;
      }

      let dataObj = {
        type: "get",
        url: "/mcbw/dep_stats/event/state_count",
        obj: {
          dateType: dateType,
          type: type,
          sortType: this.orderStatus ? "ASC" : "DESC",
          pageSize: 100,
          currentPage: 1,
          states: states,
        },
      };
      this.$Axios(dataObj).then((res) => {
        console.log("左上数据");
        console.log(res);
        this.getEchartStatus = true;
        this.echartArr = res.data.data;
        if (res.data.success && res.data.data.length) {
          this.$nextTick(() => {
            this.chartInit(res.data.data);
          });
          this.deviceDetail(res.data.data[0].orgId);
          this.echartOrgId = res.data.data[0].orgId;
          this.getTableData();
          this.parTit = res.data.data[0].name;
        }
      });
    },
    chartInit(data) {
      //左上图
      let that = this;
      let option = {
        tooltip: {
          trigger: "axis",
          formatter: function (params) {
            // console.log(params[0]);
            let res = `<div><span style="display: inline-block;width:10px;height:10px;margin-right:5px;background:none;"></span>单位：${data[params[0].dataIndex].name
              }</div>`;
            res += `<p><span style="display: inline-block;width:10px;height:10px;margin-right:5px;border-radius:10px;background:#fd6760;"></span>未处理警情：${params[0].value}</p>`;
            return res;
          },
          textStyle: {
            color: that.echarts_color,
          },
          confine: true,
        },
        calculable: true,
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          top: "15%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            data: that.name_substr(data, "name"),
            axisLine: {
              show: true,
              lineStyle: {
                color: "#122856",
              },
            },
            axisLabel: {
              textStyle: {
                color: that.echarts_color,
              },
              interval: 0,
              fontSize: 10,
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            axisLine: {
              show: true,
              lineStyle: {
                color: "transparent",
              },
            },
            axisLabel: {
              textStyle: {
                color: that.echarts_color,
              },
            },
            splitLine: {
              lineStyle: {
                color: "#122856",
              },
            },
          },
        ],
        series: [
          {
            name: that.right_bot_click_text + "数",
            type: "bar",
            data: that.name_substr(data, "value"),
            barWidth: 30,
            itemStyle: {
              normal: {
                color: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: "#fd6760", // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "#fd6760", // 100% 处的颜色
                    },
                  ],
                  globalCoord: false, // 缺省为 false
                },
              },
            },
          },
        ],
      };
      let _this = this;
      this.echartDom = this.$echarts.init(this.$refs.echart);
      this.echartDom.setOption(option);
      this.echartDom.off("click");
      this.echartDom.on("click", function (params) {
        console.log(params);
        _this.deviceDetail(params.data.orgId);
        _this.echartOrgId = params.data.orgId;
        // _this.beginTime = '';
        // _this.endTime = '';
        (_this.currentPage = 1), (_this.tableListArr = []);
        _this.getTableData();
        _this.parTit = params.data.name;
      });
    },
    name_substr(data, type) {
      let name_arr = [];
      let value_arr = [];
      for (let i = 0; i < data.length; i++) {
        if (data.length < 4 || data[i].name.length <= 4) {
          name_arr.push(data[i].name);
        } else {
          name_arr.push(data[i].name.substr(0, 4) + "...");
        }
        value_arr.push({
          value: data[i].value,
          orgId: data[i].orgId,
          name: data[i].name,
        });
      }
      if (type == "name") {
        return name_arr;
        //这里进行一下字数限制，如果大于4个字，就省略号显示
      } else {
        return value_arr;
      }
    },
    getTableData() {
      this.getDetailStatus = false;
      let url = "";
      let obj = {};
      switch (this.typeIndex) {
        case 0: //火警
          url = contBlockUrl.hjList;
          obj = {
            orgId: this.echartOrgId,
            sources: "3,6,7",
            pageSize: 50,
            currentPage: this.currentPage,
            beginTime: this.beginTime ? this.beginTime : null,
            endTime: this.endTime ? this.endTime : null,
            state: null,
            type: null,
            deviceId: this.deviceId || null,
            states: "0,1",
          };
          break;
        case 1: //报警
          url = contBlockUrl.bjList;
          obj = {
            orgId: this.echartOrgId,
            pageSize: 50,
            currentPage: this.currentPage,
            beginTime: this.beginTime ? this.beginTime : null,
            endTime: this.endTime ? this.endTime : null,
            state: null,
            type: this.baojing || null,
            deviceId: this.deviceId || null,
            states: "0,1",
          };
          break;
        case 2: //预警
          url = contBlockUrl.yjList;
          obj = {
            orgId: this.echartOrgId,
            pageSize: 50,
            currentPage: this.currentPage,
            beginTime: this.beginTime ? this.beginTime : null,
            endTime: this.endTime ? this.endTime : null,
            state: 0,
            type: this.baojing || null,
            deviceId: this.deviceId || null,
          };
          break;
        case 3: //隐患
          let inpVal = "";
          for (let i = 0; i < this.deviceDetailList.length; i++) {
            if (this.deviceDetailList[i].id == this.deviceId) {
              inpVal = this.deviceDetailList[i].name;
            }
          }
          url = contBlockUrl.yhList;
          obj = {
            pageSize: 50,
            currentPage: this.currentPage,
            orgId: this.echartOrgId,
            beginTime: new Date(this.beginTime).getTime() || null,
            endTime: new Date(this.endTime).getTime() || null,
            state: "0",
            type: null,
            deviceName: inpVal || null,
            content: null,
          };
          break;
        case 4: //故障
          url = contBlockUrl.gzList;
          obj = {
            orgId: this.echartOrgId,
            pageSize: 50,
            currentPage: this.currentPage,
            beginTime: this.beginTime ? this.beginTime : null,
            endTime: this.endTime ? this.endTime : null,
            state: 0,
            type: this.guzhang || null,
            deviceId: this.deviceId || null,
            sources: null,
          };
          break;
      }

      let dataObj = {
        type: "get",
        url: url,
        obj,
      };
      this.$Axios(dataObj).then((res) => {
        console.log(res);
        console.log("表格数据");
        this.getDetailStatus = true;
        if (res.data.success && res.data.data.length) {
          if (res.data.totalCount) {
            this.totalCount = res.data.totalCount;
          }
          this.titleTextObj = {
            chargePersonName: res.data.data[0].chargePersonName,
            chargePersonTel: res.data.data[0].chargePersonTel,
          };
          this.tableListArr = [...this.tableListArr, ...res.data.data];
          let _this = this;
          this.$nextTick(() => {
            $JQ("#layer-tem-leftTop").mCustomScrollbar({
              callbacks: {
                onTotalScroll: function () {
                  if (
                    _this.tableListArr.length == res.data.totalCount ||
                    res.data.data.length == 0
                  ) {
                    console.log("没有更多数据");
                    return;
                  } else {
                    console.log("加载更多");
                    _this.currentPage += 1;
                    _this.getTableData();
                  }
                },
              },
            });
          });
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.layer-tem {
  position: absolute;
  left: 500px;
  bottom: 0;
  width: calc(100% - 1000px);
  padding: 30px 25px;
  background: rgba(6, 18, 44, 1) url("../../assets/img/maskBg.png") center center/100% 100% no-repeat;
  z-index: 12;

  // 关闭按钮
  .close-btn {
    position: absolute;
    right: 0;
    top: 0;
    right: 15px;
    top: 15px;
    cursor: pointer;
  }

  .block-head {
    margin: 10px 0;
    display: flex;
    align-items: center;
    justify-content: space-between;

    &.block-head-form {
      justify-content: space-between;
    }

    &.block-head-text {
      color: #74d9ff;

      .text {
        margin-right: 20px;
      }
    }

    .tit {
      min-width: 150px;
      margin-right: 20px;
      flex-shrink: 0;
    }

    .tit-wrap {
      display: flex;
      align-items: center;
    }

    .right-form-wrap {
      display: flex;
      align-items: center;

      .order-wrap {
        display: flex;
        align-items: center;
        color: #74d9ff;
        cursor: pointer;

        .order-i-wrap {
          display: flex;
          flex-direction: column;

          i:first-child {
            margin-bottom: -16px;
          }

          i {
            opacity: 0.5;

            &.active {
              opacity: 1;
            }
          }
        }
      }
    }
  }

  .block-main {
    height: 200px;
    position: relative;
    padding: 8px;

    .block-main-content {
      height: 100%;

      .echart {
        height: 100%;
      }

      .no-data {
        height: 184px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #ddd;
      }

      .table-wrap {
        height: 100%;
        display: flex;
        flex-direction: column;

        .table-head {
          background: #0c2745;
          color: #7db4db;

          table th {
            height: 30px;
          }
        }

        .table-body {
          flex: 1;
          flex-shrink: 0;
          overflow: hidden;
          color: #e4eff5;

          table td {
            text-align: center;
            height: 30px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;

            i {
              cursor: pointer;
            }

            i.imgView {
              color: rgba(8, 244, 247, 0.7);
              cursor: pointer;

              &.active {
                color: rgba(8, 244, 247, 0.3);
                cursor: default;
              }
            }

            .td-option-wrap {
              display: flex;
              align-items: center;
              justify-content: center;

              i {
                margin: 0 10px;
                color: rgba(8, 244, 247, 0.3);
                cursor: default;

                &.active {
                  color: rgba(8, 244, 247, 0.7);
                  cursor: pointer;
                }
              }
            }
          }

          table tr:nth-child(2n) {
            background: #0c2745;
          }

          .no-data {
            height: 152px;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #ddd;
          }
        }

        table {
          width: 100%;
          table-layout: fixed;
          border-collapse: collapse;
        }
      }
    }
  }

  .modalImg {
    width: 500px;
    margin: 0 auto;
  }

  .xfVideo {
    display: block;
    margin: 0 auto;
  }
}

.video-title {
  display: flex;
  justify-content: space-between;
  font-size: 16px;
  color: #000;
  line-height: 40px;
  align-items: center;

  .video-btn {
    display: flex;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/layer/leftTop.vue